export default __webpack_public_path__ + "static/media/web-designing-1.6a7409ed.jpg";